import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import { useUnmount, useMount } from 'react-use'
import styled from 'styled-components'
import { customTheme } from '../../../libraries/MaterialUI'
import { useSubmitModelDialog } from './hooks'

const Root = styled(Box)`
  margin: ${customTheme.spacing(0, 1)};
`

const SubmitModelNotice = styled(Paper)`
  margin: ${customTheme.spacing(1, 0, 4, 0)};
  padding: ${customTheme.spacing(2, 2)};
  background-color: ${customTheme.palette.primary.light} !important;
`

const Component: React.FC = () => {
  const { dialog, handle } = useSubmitModelDialog()
  const { isUseDoi } = dialog
  const { handleNext, handleBack, handleUseDOI, handleInputManually, handleIsReadySearch, handleKeywords } = handle

  const [keywords, setKeywords] = React.useState<string>('')

  useMount(() => {
    handleIsReadySearch(false)
  })
  useUnmount(() => {
    handleKeywords(keywords)
  })

  return (
    <Root>
      <SubmitModelNotice>
        <Typography variant="body2">
          To add a research paper to the database, first enter its title to retrieve matching results from the Crossref
          API. For best results, enter the full title of the paper.
        </Typography>
      </SubmitModelNotice>
      <Box>
        <TextField
          id="standard-search"
          variant="outlined"
          label={isUseDoi ? 'Find paper with DOI' : 'Find paper with Title'}
          placeholder={isUseDoi ? 'i.e. 10.1021/ja803370x' : 'i.e. paper title, authors, disease category'}
          value={keywords}
          onChange={e => setKeywords(e.target.value)}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              handleNext()
            }
          }}
          type="search"
          fullWidth
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          InputLabelProps={{
            shrink: true
          }}
        />
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                size="small"
                color="primary"
                checked={isUseDoi}
                onChange={() => {
                  handleUseDOI(!isUseDoi)
                }}
              />
            }
            label={
              <Typography color="textSecondary" variant="body2">
                Want to find a paper with DOI?
              </Typography>
            }
          />
        </FormGroup>

        <Box paddingTop={1}>
          <Typography
            color="textSecondary"
            variant="caption"
            component="p"
            style={{ maxWidth: '520px', marginLeft: 'auto' }}
          >
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Can't find a paper? Skip the search step and enter details of the paper (title, author, etc.) manually at
            the end of registration. Choose tags in Sections 3 - 5 first.
          </Typography>
          <Typography align="right">
            <Link variant="body2" onClick={handleInputManually}>
              <KeyboardArrowRightIcon fontSize="small" style={{ verticalAlign: 'middle' }} />
              Input manually?
            </Link>
          </Typography>
        </Box>
      </Box>

      <Box style={{ textAlign: 'center', marginTop: '20px' }}>
        <Box style={{ margin: '10px' }}>
          <Button variant="outlined" color="primary" size="medium" onClick={() => handleNext()}>
            Go to select paper
          </Button>
        </Box>
        <Box style={{ margin: '10px' }}>
          <Button variant="text" color="default" size="small" onClick={handleBack}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Root>
  )
}

export default Component
